import moment from 'moment'

export default function getCurrentDate() {
  return moment();
}